import React from "react";
import { useForm, SubmitHandler, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Input from "components/Input";
import Select from "react-select";
import apiService from "services/apiService";
import { colors } from "themes";
import { customSelectStyles } from "util/selectStyles";

const schema = yup.object().shape({
  gender: yup.string().required(),
  designation: yup.string().required(),
  userStatus: yup.string().required(),
  role: yup.number().required(),
});

interface AddProps {
  onClose: () => void;
}
interface GenderOption {
  value: string;
  label: string;
}

interface userOptions {
  value: number;
  label: string;
}
export default function AddEmployee({ onClose }: AddProps) {
  const methods = useForm({ resolver: yupResolver(schema) });
  
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onSubmit: SubmitHandler<any> = (data: any) => {
    console.log("data", data);
    apiService
      .post("api/user", data)
      .then((res) => {
        console.log("res", res);
      })
      .catch((err) => {
        console.log("err :>> ", err);
      })
      .finally(() => {
        onClose();
      });
    // onClose();
  };
  const statusOptions: GenderOption[] = [
    { value: "ACTIVE", label: "ACTIVE" },
    { value: "INACTIVE", label: "INACTIVE" },
  ];
  const userOptions: userOptions[] = [
    { value: 1, label: "User" },
    { value: 2, label: "Admin" },
    { value: 3, label: "Sys_Admin" },
    { value: 4, label: "Manager" },
  ];
  const genderOptions: GenderOption[] = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" },
  ];
  const options = [
    { value: "Web Developer", label: "Web Developer" },
    { value: "Java Developer", label: "Java Developer" },
    { value: "Developer", label: "Developer" },
    { value: "Windows developer", label: "Windows developer" },
    { value: "Programmer", label: "Programmer" },
    { value: "Systems Analyst", label: "Systems Analyst" },
    { value: "Software engineer", label: "Software engineer" },
    { value: "Fullstack Developer", label: "Fullstack Developer" },
    { value: "HR manager", label: "HR manager" },
    { value: "Android Developer", label: "Android Developer" },
    { value: "IOS Developer", label: "iOS Developer" }, // Corrected capitalization
    { value: "QA Engineer", label: "QA Engineer" },
    { value: "Test Manager", label: "Test Manager" },
    { value: "Test Engineer", label: "Test Engineer" },
    { value: "Test Analyst", label: "Test Analyst" },
    { value: "Test Automation Engineer", label: "Test Automation Engineer" },
  ];

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <div className="grid gap-4 grid-cols-2">
            <Input
              name="displayName"
              label="Full Name"
              placeholder={`Enter Full Name`}
              required
            />
            <Input
              name="email"
              label="Email Address"
              placeholder={`Enter Email Address`}
              required
            />
            <Input name="doj" label="Date Of Joining" type="date" />
            <Input
              name="mobileNumber"
              label="Mobile Number"
              placeholder={`Enter Mobile Number`}
              type="number"
            />
            <div className="mb-4">
              <label> Select Gender</label>
              <Select
                {...methods.register("gender", { required: true })}
                options={genderOptions}
                placeholder="Select Gender"
                styles={customSelectStyles}
                className="w-full rounded-xl border border-slate-200 dark:border-slate-700 focus:outline-none focus:ring-1 focus:ring-primary dark:bg-slate-800 transition-all shadow-sm"
                onChange={(selectedOption) => {
                  selectedOption &&
                    methods.setValue("gender", selectedOption.value);
                }}
              />
              {methods.formState.errors.gender && (
                <span className="text-error text-sm mt-1">
                  {methods.formState.errors.gender.message}
                </span>
              )}
            </div>

            <div className="mb-4">
              <label> Designation</label>
              <Select
                {...methods.register("designation", { required: true })}
                options={options}
                placeholder="Select Designation"
                styles={customSelectStyles}
                className="w-full rounded-xl border border-slate-200 dark:border-slate-700 focus:outline-none focus:ring-1 focus:ring-primary dark:bg-slate-800 transition-all shadow-sm"
                onChange={(selectedOption) => {
                  selectedOption &&
                    methods.setValue("designation", selectedOption.value);
                }}
              />
              {methods.formState.errors.designation && (
                <span className="text-error text-sm mt-1">
                  {methods.formState.errors.designation.message}
                </span>
              )}
            </div>
            <div className="mb-4">
              <label> Select Status</label>
              <Select
                {...methods.register("userStatus", { required: true })}
                options={statusOptions}
                placeholder="Select Status"
                styles={customSelectStyles}
                className="w-full rounded-xl border border-slate-200 dark:border-slate-700 focus:outline-none focus:ring-1 focus:ring-primary dark:bg-slate-800 transition-all shadow-sm"
                onChange={(selectedOption) => {
                  selectedOption &&
                    methods.setValue("userStatus", selectedOption.value);
                }}
                // defaultValue={statusOptions.find((option) => option.value === data.userStatus)}
              />
              {methods.formState.errors.userStatus &&
                methods.formState.errors.userStatus.message && (
                  <span className="text-error text-sm mt-1">
                    {methods.formState.errors.userStatus.message}
                  </span>
                )}
            </div>
            <div className="mb-4">
              <label> Select Role</label>
              <Select
                {...methods.register("role", { required: true })}
                options={userOptions}
                placeholder="Select Role"
                styles={customSelectStyles}
                className="w-full rounded-xl border border-slate-200 dark:border-slate-700 focus:outline-none focus:ring-1 focus:ring-primary dark:bg-slate-800 transition-all shadow-sm"
                onChange={(selectedOption) => {
                  selectedOption &&
                    methods.setValue("role", selectedOption.value);
                }}
                // defaultValue={userOptions.find((option) => option.value === data.role)}
              />
              {methods.formState.errors.role &&
                methods.formState.errors.role.message && (
                  <span className="text-error text-sm mt-1">
                    {methods.formState.errors.role.message}
                  </span>
                )}
            </div>
          </div>

          <div className="flex justify-center">
            <button
              type="submit"
              style={{ backgroundColor: colors.primary }}
              className="hover:opacity-90 text-white px-8 py-2.5 rounded-xl font-bold transition-all active:scale-95 shadow-lg"
            >
              Submit
            </button>
          </div>
        </form>
      </FormProvider>
    </>
  );
}
